export const styledGithubMessage = {
    '& > ul': {
        '& > li': {
            '& a': {
                '& svg': {
                    '&:last-child': {marginRight: 0},
                    'marginRight': '6px',
                    'verticalAlign': '-3px',
                },
                '&:first-child': {marginLeft: 0},
                'margin': '0px 6px',
            },
            '&:last-of-type': {marginBottom: '0px'},
            'marginBottom': '6px',
        },
        'listStyleType': 'none',
        'margin': 0,
        'padding': 0,
    },
}

export const styledAction = {
    color: '$success',
    marginLeft: '6px',
}

export const styledName = {whiteSpace: 'nowrap'}
